import NodeApi from "./requests/node-api";
import Cookies from "js-cookie";
import { generateABBucket } from "../utils/generateAbbucket";
export default (config) => {
    const request = NodeApi.getInstance().request;
    const userAbBucket = Cookies.get("userABBucket") || generateABBucket();
    return request.get(`/listings/listing-view/${config === null || config === void 0 ? void 0 : config.postId}/v3?abBucket=${userAbBucket}`, {
        headers: Object.assign({}, config === null || config === void 0 ? void 0 : config.headers)
    });
};
